export const AUTH_PROVIDER_CAMVIO = "INTERNAL";
export const AUTH_PROVIDER_AUTH0 = "AUTH0";